import React from 'react';

const Suggestions = ({ currentSuggestions, onSuggestionClick, isTyping, skipTyping, typingIntervalRef, messages, setMessages, setIsTyping }) => {
    return (
        <div className="p-4 border-t border-white/10 bg-cyber-gray/5 backdrop-blur-sm">
            <div className="flex justify-between items-center mb-3">
                <div className="text-primary/60 text-sm font-mono">Try asking about:</div>
                {isTyping && (
                    <button
                        onClick={() => skipTyping(messages, typingIntervalRef, setMessages, setIsTyping)}
                        className="px-3 py-1 text-xs font-mono rounded-md 
                                 bg-primary/10 text-primary/80 hover:bg-primary/20 
                                 transition-colors duration-200 border border-primary/20
                                 hover:border-primary/40 focus:outline-none focus:ring-1 
                                 focus:ring-primary/50"
                    >
                        Skip typing
                    </button>
                )}
            </div>
            <div className="overflow-x-auto sm:overflow-x-visible pb-2 sm:pb-0 scrollbar-hide">
                <div className="flex sm:flex-wrap gap-2 w-max sm:w-auto">
                    {currentSuggestions.map((suggestion, index) => (
                        <button
                            key={`${suggestion}-${index}`}
                            onClick={() => onSuggestionClick(suggestion)}
                            disabled={isTyping}
                            className={`shrink-0 px-3 py-1.5 text-sm font-mono rounded-md 
                                     bg-white/5 text-primary/80 hover:bg-white/10 
                                     transition-colors duration-200 border border-white/10
                                     hover:border-white/20 focus:outline-none focus:ring-1 
                                     focus:ring-white/20 hover:scale-105 
                                     transform transition-transform duration-200
                                     ${isTyping ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {suggestion}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Suggestions; 